import * as React from 'react';
import { connect } from 'react-redux';

import { IPostcardImage, IDocument } from '../../infrastructure/interfaces';
import PostcardImageBackEditorForm from '../DocumentEditor/PostcardImageBackEditorForm';
import {
  changePostcardImageBack,
} from '../../actions/actions';

export interface IPostcardImagessChoosingProps {
  document: IDocument;
  postcardImagesList: IPostcardImage[];
  changePostcardImageBack(image: IPostcardImage): void;
}

export interface IPostcardImagessChoosingState { }

const mapDispatchToProps = (dispatch: any): any => {
  return {
    changePostcardImageBack: (image: IPostcardImage): void => {
      dispatch(changePostcardImageBack(image));
    },
  };
};

const mapStateToProps = (state: any): any => {
  return {
    document: state.document,
    postcardImagesList: state.wizard.postcardImages,
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class PostcardImagessChoosing extends React.Component<any, any> {
  render() {
    return (
      <div>
        <div className="stepHeader">
          <div className="stepMessage">
            Choose the back postcard background image:
          </div>
          <div className="stepMessage2">
            You can change this selection later
        </div>
        </div>
        <PostcardImageBackEditorForm
          className="stepContent settingsCropsListContainer settingsCropsListContainer--crops"
          document={this.props.document}
          postcardImagesList={this.props.postcardImagesList}
          onPostcardImageChangeBack={this.props.changePostcardImageBack}
        />
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/Steps/PostcardImageListBackChoosing.tsx